{
  "version": 1,
  "asset_id": "af098b91-ec3f-42b9-9109-7db495f2475f",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/af098b91-ec3f-42b9-9109-7db495f2475f/schwenk-logistik.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/af098b91-ec3f-42b9-9109-7db495f2475f/schwenk-logistik.png",
  "original_filename": "schwenk-logistik.png",
  "size": 109301,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:54Z"
}
